export default {
  testimonial: {},
  singleTestimonial: {},
  redirect: false,
};
